import React, { useState, useEffect, useRef, useMemo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import Autocomplete, {
  createFilterOptions,
} from "@mui/material/Autocomplete";

const useStyles = makeStyles((theme) => ({
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1.1rem 0rem 0rem",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
    "& .MuiInputLabel-outlined": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
      transform: "translate(14px, 13px) scale(1)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0.75)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    "& .MuiAutocomplete-tag": {
      fontSize: "12px",
      fontFamily: '"Source Sans Pro",sans-serif',
      height: "24px",
    },
    '& .Mui-disabled' : {
      color: "#000000",
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#605f70',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#605f70',
      },
    },
  },
}));

export default function AutocompleteMultiselectInputById(props) {
  const {
    inputTitle,
    selected,
    list,
    handleChange,
    specialWidth,
    name,
    isRequired,
    isMultiple,
  } = props;

  const classes = useStyles();
 //console.log(list);

  return (
    // <div>
    <div className={classes.input}>
      {/* <text className={classes.inputTitle}>{inputTitle}</text> */}
      <Autocomplete
       disabled={props.disabled}
        multiple={isMultiple}
        style={{ width: specialWidth }}
        id="tags-standard"
        name={name}
        value={selected}
        options={list}
        getOptionLabel={(option) => option.name}
        getOptionSelected={(selected, list) => selected.id === list.id}
        onChange={(_, newValue) => {
          handleChange(newValue);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            required={isRequired}
            style={{ margin: "2px 8px" }}
            variant="outlined"
            label={inputTitle}
            placeholder="Ajouter"
            className={classes.textField}
          />
        )}
      />
    </div>
  );
}

AutocompleteMultiselectInputById.defaultProps = {
  specialWidth: "99%",
  isRequired: false,
  isMultiple: true,
};

AutocompleteMultiselectInputById.propTypes = {
  isMultiple: PropTypes.bool,
  isRequired: PropTypes.bool,
  specialWidth: PropTypes.string,
  inputTitle: PropTypes.any,
  dateInput: PropTypes.any,
  handleDateInputChange: PropTypes.any,
};
